/* Keep storefront brand copy consistent while preserving addresses and existing links. */
(() => {
  const homeUrl = document.currentScript.dataset.homeUrl;
  const aboutUrl = document.currentScript.dataset.aboutUrl;
  const scope = '#header-group, #MainContent, footer';
  const excluded = 'script, style, textarea, input, select, option, svg, math, noscript, [contenteditable], .icd-brand-heart';
  const heartPattern = /[❤♥][\uFE0E\uFE0F]?/g;
  // Do not turn email addresses, domain names, handles, or filenames into display copy.
  const plainBrand = /(?<![\p{L}\p{N}_@./-])ilovecatndog(?![\p{L}\p{N}_@./-])/giu;
  const displayBrand = /I\s*[❤♥][\uFE0E\uFE0F]?\s*Cat\s*&\s*Dog/i;

  function formatBrand(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (node.parentElement?.closest(scope) && !node.parentElement.closest(excluded)) nodes.push(node);
    }
    for (const node of nodes) {
      const copy = node.data.replace(plainBrand, 'I ❤ Cat&Dog');
      if (copy !== node.data) node.data = copy;
      if (node.parentElement.closest('a, button')) continue;
      const context = node.parentElement.closest('.icd-footer__eyebrow, .icd-about__intro, .icd-story__body');
      if (!context || context.querySelector('[data-icd-brand-link]')) continue;
      const match = node.data.match(displayBrand);
      if (!match) continue;
      const link = document.createElement('a');
      link.className = 'icd-brand-link';
      link.dataset.icdBrandLink = '';
      link.href = context.matches('.icd-story__body') ? aboutUrl : homeUrl;
      link.textContent = match[0];
      const fragment = document.createDocumentFragment();
      fragment.append(node.data.slice(0, match.index), link, node.data.slice(match.index + match[0].length));
      node.replaceWith(fragment);
    }
    colorHearts(root);
  }

  function colorHearts(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (/[❤♥]/.test(node.data) && node.parentElement?.closest(scope) && !node.parentElement.closest(excluded)) {
        nodes.push(node);
      }
    }
    for (const node of nodes) {
      const fragment = document.createDocumentFragment();
      let offset = 0;
      for (const match of node.data.matchAll(heartPattern)) {
        fragment.append(node.data.slice(offset, match.index));
        const heart = document.createElement('span');
        heart.className = 'icd-brand-heart';
        // Text presentation keeps the brand red consistent across emoji fonts.
        heart.textContent = match[0][0] + '\uFE0E';
        fragment.append(heart);
        offset = match.index + match[0].length;
      }
      fragment.append(node.data.slice(offset));
      node.replaceWith(fragment);
    }
  }

  formatBrand(document.body);
  // Shopify replaces section markup when settings are edited or sections reload.
  const observer = new MutationObserver((records) => {
    const roots = new Set();
    for (const record of records) {
      const target = record.target.nodeType === Node.TEXT_NODE ? record.target.parentElement : record.target;
      if (target?.closest(scope) && !target.closest(excluded)) {
        roots.add(target);
      }
      for (const added of record.addedNodes) {
        if (added.nodeType === Node.ELEMENT_NODE && !added.closest(excluded) && (added.closest(scope) || added.querySelector(scope))) {
          roots.add(added);
        }
      }
    }
    observer.disconnect();
    roots.forEach(formatBrand);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  });
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });
})();
